import { UserDetailsService } from "./../../login/services/UserDetails.service";
import { KeycloakService } from "keycloak-angular";
import { Component, inject, OnInit, Renderer2 } from "@angular/core";
import { SidenavService } from "../../service/sidenav.service";
import { TitleService } from "../../service/title.service";
import { DatastoreService } from "../../datastore/service/datastore-service";
import { ConfigService } from "../../../app/utils/config.service";
import { toSignal } from "@angular/core/rxjs-interop";
import { combineLatest, map, switchMap, takeWhile, timer } from "rxjs";
import { AppService } from "src/app/service/app.service";

@Component({
  selector: "app-header",
  templateUrl: "header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit {
  private titleName: String = "";

  public username: string;

  public currentPageTitle: string;

  public defaultDatastore: string;

  public tenantDisplayName: string;

  private role = ConfigService.settings.role;

  private baseHelpUrl = ConfigService.settings.baseHelpUrl;

  private _appService = inject(AppService);

  appTitle = ConfigService.settings.app?.title ?? 'Facilis.aero AIM';

  appStatus = toSignal(
    combineLatest({
      basexStatus: timer(0, 60000).pipe(switchMap(() => this._appService.getBasexStatus())),
      onlineStatus: this._appService.getOnlineStatus(),
    }).pipe(
      map((response) => {
        if (!response.onlineStatus) {
          return {
            status: "offline",
            label: "Offline",
            tooltipMessage: "System unavailable. Please try again later or contact support.",
          };
        }

        if (response.basexStatus.blocked) {
          return {
            status: "blocked",
            label: "Maintenance",
            tooltipMessage: "System online but in maintenance. Some functions unavailable, especially data updates.",
          };
        }

        if (response.onlineStatus) {
          return { status: "online", label: "Operational", tooltipMessage: "System online. All functions available." };
        }
      })
    )
  );

  constructor(
    private sidenavService: SidenavService,
    private titleService: TitleService,
    private keycloakService: KeycloakService,
    private userDetailsService: UserDetailsService,
    private datastoreService: DatastoreService,
    private render: Renderer2
  ) {}

  ngOnInit() {
    this.username = this.userDetailsService.getUser().username;
    this.currentPageTitle = this.titleService.getTitle();
    this.defaultDatastore = this.userDetailsService.getDefaultDatastore();
    this.datastoreService.getDatastoreName().subscribe((result) => (this.tenantDisplayName = result));
  }

  toggleRightSidenav() {
    this.sidenavService.toggle();
  }

  logout(): void {
    this.keycloakService.logout();
  }

  // Check the current user has ROLE_FAIVA_MODULE role
  hasValidatorModuleRole(): boolean {
    return this.userDetailsService.hasRole(this.role.role_Validator_Module);
  }

  // Check the current user has ROLE_FACILIS_ORIGIN_MODULE
  hasFOModuleRole(): boolean {
    return this.userDetailsService.hasRole(this.role.role_FO_Module);
  }

  // Check the current user has ROLE_AIS_ADMIN
  hasAdminRole(): boolean {
    return this.userDetailsService.hasRole(this.role.role_Ais_Admin);
  }

  openHelp() {
    let selectedUrl = this.hasValidatorModuleRole() ? this.baseHelpUrl.faivaDocUrl : this.baseHelpUrl.xwikiUrl;
    const newWindow = window.open(selectedUrl, "_blank");
    if (newWindow) {
      newWindow.focus();
    }
  }
}
